import { z } from "zod";

import { NO_DISPLAY, YES_DISPLAY } from "@/intake-forms/constants/yes-no-display";
import { zSignatureInitialsRequired } from "@/utils/zod";

const numericOrEmptyField = z.union([z.string(), z.number()]).optional();
const yesNoDisplayField = z.enum([YES_DISPLAY, NO_DISPLAY]).nullable().optional();

export const contractionsFlowsheetFormSchema = z.object({
  contractionDate: z.date().nullable(),
  contractionTime: z.string().nullable(),
  frequency: numericOrEmptyField,
  duration: numericOrEmptyField,
  strength: z.string().nullable().optional(),
  coping: yesNoDisplayField,
  notes: z.string().optional(),
  signatureInitials: zSignatureInitialsRequired(),
});

export type ContractionsFlowsheetFormSchemaType = z.infer<typeof contractionsFlowsheetFormSchema>;
